export abstract class BaseStreamingComponent extends HTMLElement {
	protected isStreaming: boolean = false;
	protected streamingBuffer: string = '';

	setStreamingState(isStreaming: boolean): void {
		this.isStreaming = isStreaming;
		this.updateStreamingIndicator();
	}

	appendStreamingContent(content: string): void {
		this.streamingBuffer += content;
		this.updateContent();
	}

	completeStreaming(): void {
		this.isStreaming = false;
		this.streamingBuffer = '';
		this.updateStreamingIndicator();
	}

	protected abstract updateContent(): void;
	protected abstract updateStreamingIndicator(): void;
}



